import {createStore} from '@ngneat/elf';
import {
  addEntities,
  deleteEntities,
  selectAllEntities,
  setEntities,
  updateEntities,
  withEntities
} from '@ngneat/elf-entities';
import {CollectionItem} from '@sim/collections/models/collection';


export const store = createStore({name: 'collectionItem'}, withEntities<CollectionItem>());

export const collectionItems$ = store.pipe(selectAllEntities());

export function setCollectionItem(collectionItem: CollectionItem[]) {
  store.update(setEntities(collectionItem));
}

export function addCollectionItem(collectionItem: CollectionItem) {
  store.update(addEntities(collectionItem));
}

export function updateCollectionItem(id: CollectionItem['id'], collectionItem: Partial<CollectionItem>) {
  store.update(updateEntities(id, collectionItem));
}

export function deleteCollectionItem(id: CollectionItem['id']) {
  store.update(deleteEntities(id));
}
